<template lang="html">
  <div class="eitiaSignIn">
    <!-- 头部 -->
    <div class="header">
      <img class="logo" src="@/assets/image/eitia/logo.png" alt="">
      <div class="activityTime">
        2024.3.1～3.2 共襄盛会
      </div>
    </div>

    <div class="eitiaCon" v-if="type == 0">
      <!-- 基本信息 -->
      <div class="basicInfo">
        <div class="userInfo">
          <input placeholder="请输入您的电话" name="infoInput" class="infoInput" type="text" v-model="userPhone">
        </div>

        <div class="userInfo code">
          <input placeholder="请输入您的验证码" name="infoInput" class="infoInput codeInput" type="text" v-model="code">
          <div class="getCode" :class="{checkValid: codeEnabled}" @click="debouncedGetSmsCode">{{buttonMsg}}</div>
        </div>
      </div>

      <div class="signInBtn" :class="{signInBtnElse: submitEnabled}" @click="getSubmit">
        签到
      </div>
    </div>

    <!-- 未参与活动 已签到 -->
    <div class="signInType" v-else-if="type == 1">
      <img src="@/assets/image/eitiaSignIn/icon7.png" alt="">
      <p>您还未完成大会报名，正在为您跳转至报名地址…{{buttonMsgElse}}</p>
    </div>

    <!-- 参与活动 已签到 -->
    <div class="signInSucceed" v-else-if="type == 2">
      <img src="@/assets/image/eitiaSignIn/icon3.png" alt="" class="succeedImg">
      <h4>签到成功！</h4>
      <p class="hint1">您的信息已登记在现场屏幕墙中～</p>
      <p class="hint2">同时为您准备了精彩的EITIA大会 <br> 元宇宙世界</p>
      <div class="experienceBtn" @click="getEcosmos">立即体验</div>
      <p class="experienceHint" @click="copeText()">您也可以使用电脑版Chrome浏览器打开 <span>https://ecosmos.elecnest.com/</span> ，已获得更好的观看体验</p>
    </div>

    <div v-show="hintShow" class="hintMod" :class="{hintModElse: hintModElseType}">
      <p>{{hintCon}}</p>
    </div>
  </div>
</template>

<script>
  import utils from '@/utils/utils'
  // 防抖
  import { debounce } from 'lodash';

  var phone = /^1[3456789]\d{9}$/;
  var unmber = /^[0-9]+$/;

  export default {
    data() {
      return {
        userPhone: '',
        code: '',
        limitTime: 60,
        buttonMsg: '获取验证码',
        codeEnabled: false,
        hintShow: false,
        hintTime: 1,
        hintCon: '',
        type: 0,

        buttonMsgElse: '',
        eitiaSignInLimitTime: 5,
        hintModElseType: 0,
      }
    },

    computed: {
      submitEnabled() {
        return this.userPhone && this.code
      },
    },

    mounted() {
      document.title = 'EITIA电子互连技术创新大会';
    },

    methods: {

      // 获取验证码
      getSmsCode() {
        if (this.userPhone != '') {
          if (this.limitTime == 60) {
            this.$http.get('/Registered/getPhoneSmsCode', {
              params: utils.cso({
                phone: this.userPhone,
                phone_head: 86,
                type: 10,
                client: 'H5'
              })
            }).then((res) => {
              if (res.code >= 0) {
                this.buttonMsg = this.limitTime + 's后重试'
                this.timer = window.setInterval(() => {
                  this.limitTime--
                  this.buttonMsg = this.limitTime + 's后重试'
                  if (this.limitTime < 0) {
                    window.clearInterval(this.timer)
                    this.buttonMsg = '获取验证码'
                    this.limitTime = 60
                  }
                }, 1000)
              } else {
                this.setHintCon(res.msg);
              }
            })
          } else {
            this.setHintCon("短信已经发送,5分钟内请勿重复点击");
          }
        } 
      },

      // 5s 倒计时
      getCountDown () {
        this.buttonMsgElse = this.eitiaSignInLimitTime + 's'
        this.timers = window.setInterval(() => {
          this.eitiaSignInLimitTime--
          this.buttonMsgElse = this.eitiaSignInLimitTime + 's'

          if (this.eitiaSignInLimitTime <= 0) {
            window.clearInterval(this.timers)
            this.buttonMsgElse = '0s';
            this.eitiaSignInLimitTime = 5;

            this.$router.push({
              path: '/eitiaHome',
              query: {
                sign: '1',
              }
            })
          }
        }, 1000)
      },

      getSubmit() {
        // 电话
        if (phone.test(this.userPhone) && this.userPhone) {
          // 验证码
          if (unmber.test(this.code) && this.code) {
            this.$http({
              url: '/meet/setSignIn',
              method: 'post',
              params: {
                phone: this.userPhone,
                sms_code: this.code,
              },
            }).then((res) => {
              if (res.code >= 0) {
                this.type = 2;
              } else {
                if (res.code == -11) {
                  this.setHintCon(res.msg)
                } else if(res.code == -429) {
                  this.setHintCon(res.msg)
                } else {
                  this.type = 1;
                  this.getCountDown();
                }
              }
            })
          } else {
            this.setHintCon('请输入验证码')
            window.scrollTo(0, 100)
          }
        } else {
          if (this.userPhone != '') {
            this.setHintCon('电话有误，请检查')
          } else {
            this.setHintCon('请输入您的电话')
          }
          window.scrollTo(0, 100);
        }
      },

      // 提示信息
      setHintCon(e) {
        window.clearInterval(this.timers)
        this.hintCon = e;
        this.hintShow = true;
        this.timers = window.setInterval(() => {
          this.hintTime--
          if (this.hintTime < 0) {
            window.clearInterval(this.timers)
            this.hintShow = false
            this.hintTime = 1
          }
        }, 1000)
      },

      getEcosmos(){
        window.location.href = 'https://ecosmos.elecnest.com/';
      },

      copeText(){
        const input = document.createElement('input')
        document.body.appendChild(input)
        input.setAttribute('value', 'https://ecosmos.elecnest.com/')
        input.select()
        if (document.execCommand('copy')) {
          document.execCommand('copy')
        }
        document.body.removeChild(input)
        this.hintModElseType = 1;
        this.setHintCon('复制成功')
      },

      debouncedGetSmsCode: debounce(function(){
        this.getSmsCode()
      }, 500),
    }
  }
</script>

<style lang="css" scoped>
  .eitiaSignIn {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    background: linear-gradient(#0026BD, #223BCA);
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  /* 头部基础信息 */
  .header {
    box-sizing: border-box;
    width: 100%;
    height: 22.3rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-image: url('~@/assets/image/eitia/back6.png');
    background-repeat: no-repeat;
    background-size: cover;
  }

  .logo {
    width: 24.2rem;
    margin-top: 4.5rem;
  }

  .activityTime {
    width: 22.1rem;
    height: 2.6rem;
    background-image: url('~@/assets/image/eitia/back2.png');
    background-repeat: no-repeat;
    background-size: contain;
    font-size: 1.4rem;
    color: #FFFFFF;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 1rem;
  }

  /* 内容 */
  .eitiaCon {
    width: 100%;
    box-sizing: border-box;
    padding: 0 2rem;
  }

  /* 基本信息 */
  .basicInfo {
    box-sizing: border-box;
    width: 100%;
    margin-top: 1.05rem;
  }

  .userInfo {
    box-sizing: border-box;
    width: 100%;
    height: 4.7rem;
    margin-top: 1.5rem;
    padding: 1.3rem 1.5rem;
    background: linear-gradient(to right, #2A39DA, #00B0EE);
    background-color: rgba(0, 0, 0, 0.25);
    backdrop-filter: blur(7px);
    border-radius: .6rem;
    border: .05rem solid #33FFD3;
  }

  .code {
    display: flex;
    justify-content: space-between;
  }

  .infoInput {
    width: 100%;
    height: 100%;
    background-color: transparent;
    border: none;
    outline: none;
    color: #00FEFF;
    font-size: 1.5rem;
  }

  .infoInput[name="infoInput"]::-webkit-input-placeholder {
    color: #A6D0FF;
  }

  .codeInput {
    width: 70%;
  }

  .getCode {
    width: 7.5rem;
    font-size: 1.4rem;
    color: #FFFFFF;
    text-align: end;
  }

  /* 签到 */
  .signInBtn {
    width: 100%;
    height: 4.9rem;
    background-color: rgba(48, 255, 197, 0.7);
    font-size: 1.7rem;
    line-height: 4.9rem;
    text-align: center;
    margin-top: 5.8rem;
    border-radius: .5rem;
  }

  .signInBtnElse {
    background-color: #30FFC5;
  }

  /* 未报名 */
  .signInType {
    box-sizing: border-box;
    width: 28.4rem;
    height: 15.45rem;
    background-color: #FFFFFF;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 2.1rem;
    border-radius: 1rem;
    margin-top: 5rem;
  }

  .signInType img {
    width: 2.8rem;
    height: 2.8rem;
    animation: spin 2s linear infinite;
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  .signInType p {
    font-size: 1.6rem;
    color: #0D206E;
    margin-top: 1rem;
  }

  /* 签到成功 */
  .signInSucceed {
    box-sizing: border-box;
    width: 100%;
    height: 90%;
    background-color: #FFFFFF;
    border-radius: 2rem 2rem 0 0;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .signInSucceed .succeedImg {
    width: 5rem;
    height: 5rem;
    margin-top: 4rem;
  }

  .signInSucceed h4 {
    margin-top: 1.8rem;
  }

  .signInSucceed .hint1 {
    margin-top: .35rem;
    font-size: 1.4rem;
    color: #555555;
  }

  .signInSucceed .hint2 {
    margin-top: 8rem;
    font-size: 1.6rem;
    font-weight: 600;
    color: #333333;
    text-align: center;
    line-height: 2.5rem;
  }

  .signInSucceed .experienceBtn {
    width: 21.5rem;
    height: 4.4rem;
    border-radius: 4.4rem;
    background-color: #1E28BE;
    color: #FFFFFF;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 2.55rem;
  }
  
  .experienceHint {
    font-size: 1.2rem;
    text-align: center;
    margin-top: 1rem;
  }

  .experienceHint span {
    color: #00B0EE;
    border-bottom: .1rem solid #00B0EE;
  }

  /* 提示 */
  .hintMod {
    box-sizing: border-box;
    position: fixed;
    bottom: 45%;
    left: 0;
    display: flex;
    justify-content: center;
    width: 100%;
  }

  .hintMod p {
    box-sizing: border-box;
    padding: 0 1.5rem;
    background-color: rgba(255, 255, 255, 1);
    font-size: 1.3rem;
    color: #000000;
    max-width: 65%;
    height: 4rem;
    border-radius: 4rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .hintModElse p{
    background-color: rgba(0, 0, 0, 0.60);
    color: #FFFFFF;
  }
</style>
